module.exports = __webpack_public_path__ + "img/lastmove-button.5879533a.svg";